<template>
  
  <div class="container"
    style="width: 100%;margin: 0px;padding: 0px;max-width: 100%;min-height: max-content;z-index: 0;height: auto;overflow-y:hidden">
    <div class="row gx-0 gy-0 justify-content-center align-items-center"
      style="background: transparent;overflow-x: clip;min-height: 90vh;">
      <div class="col d-grid justify-content-xl-center align-items-xl-center zstack custom-col order-sm-1"
        style="background: transparent;overflow-x: visible;grid-column: 1;grid-row: 1;overflow-y: visible;padding-right: 1rem;padding-left: 1rem;">
        <div style="width: 100%;height: 100%;overflow-x: visible;place-self: center center;opacity: 1;">
          <div class="blurryCircle"
            style="background: rgb(13,110,253);width: 50vw;height: 50vw;min-height: 10rem;min-width: 10rem;place-self: end end;border-radius: 9999px;position: relative;/*left: 50%;*/top: 50%;z-index: -1;transform: translate3d(0, 0, 0);">
          </div>
        </div>
        <div
          class="text-center d-flex d-xl-flex flex-column justify-content-center align-items-center justify-content-xl-center align-items-xl-center zstack materialBackground"
          style="width: auto;border-radius: 15px;box-shadow: 0px 0px 19px rgba(0,0,0,0.24);aspect-ratio: 1/1;height: auto;overflow: clip;padding: 2rem;max-height: 30rem;">
          <h1 class="text-center" style="justify-self: start;margin-bottom: auto;">Log In To Our Resource Hub</h1>
        <template v-if="$route.query.unverified && user">
            <p style="font-size: 0.9rem;">A link to verify your email has been sent to your inbox, please check your spam folder if you don't see it.</p>
            <button :disabled="cooldownActive" class="btn btn-primary" type="button" @click="resendVerification" style="margin-top: auto;margin-right: 23px;">{{ cooldownActive ? 'Wait ' + cooldown + ' seconds to resend' : 'Resend Verification' }}</button>
        </template>
            <p style="font-size: 0.9rem;" v-else-if="$route.query.resetSent">A link to reset your password has been sent to your inbox, please check your spam folder if you don't see it.</p>
          <form @submit.prevent="login" class="d-flex d-xl-flex flex-column px-5 justify-content-xl-center align-items-xl-center gap-2" style="width: 100%;height: 100%;">

            <input class="form-control" v-model="email" type="email" name="Email" placeholder="Email" inputmode="email" required="" style="margin-top: auto;">
            <input class="form-control" v-model="password" type="password" placeholder="Password" name="Password" required="">
            <NuxtLink to="/resources/resetPassword">Forgot Password?</NuxtLink>
            <button :disabled="signingIn" class="btn btn-primary" type="submit" style="margin-top: auto;">Login</button>

            <NuxtLink to="/resources/signup" type="submit" style="">Don't have an account?</NuxtLink>

        </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getAuth, signInWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';

useHead({
    title: "Resource Hub - Log In | AIBoosted"
})

const description = "Check out the free AIBoosted resource hub for all the latest resources to kickstart your AI Automation journey!"

const meta = {
    title: "Resource Hub | AIBoosted",
    description,
    ogDescription: description,
    twitterDescription: description
}

useServerSeoMeta(meta)
useSeoMeta(meta)

const email = ref("");
const password = ref("");
const pressedSubmitOnce = ref(false)

const auth = getAuth();
const user = useCurrentUser();

const cooldown = ref(60)

const cooldownActive = computed(() => {
  return cooldown.value > 0;
});

let cooldownTimerInterval = null


function startCooldownTimer() {
    cooldown.value = 60
    cooldownTimerInterval = setInterval(function () {
      cooldown.value--;
      if (cooldown.value <= 0) {
        clearInterval(cooldownTimerInterval);
      }
    }, 1000)
}

async function resendVerification() {
  if (!user.value) {
    return;
  }
  try {
    const redirectUrl = window.location.origin + "/resources/login?verified=true"
    await sendEmailVerification(user.value, {
      url: redirectUrl
    })
    startCooldownTimer()
    
    alert('Verification email sent.');
  } catch (error) {
    alert('Error sending verification email: ' + error.message);
  }
}

const signingIn = ref(false)
const route = useRoute()
const login = async () => {
  signingIn.value = true;
  pressedSubmitOnce.value = true;

  if (!password.value || !email.value) {
    signingIn.value = false;
    return;
  }

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email.value, password.value);

    if (!userCredential.user.emailVerified) {
      alert("Please verify your email address before logging in.");
      navigateTo({
        path: "/resources/login",
        query: {
          unverified: true
        }
      })
      return;
    }

    // Redirect to another page after successful login
    if (route.query.redirectedFrom) {
      navigateTo({
        path: route.query.redirectedFrom
      })
    } else {
      navigateTo({
        path: "/resources"
      })
    }
  } catch (error) {
    alert("Error logging in: " + error.message);
  } finally {
    signingIn.value = false;
  }
};

onMounted(startCooldownTimer)
</script>

<style scoped>
.text-danger {
  color: red;
}
</style>
